export default {"src":"/_next/static/media/samsungPay.58e0542e.svg","height":468,"width":470,"blurWidth":0,"blurHeight":0};